import { useState } from "react";
import axios from "axios";
import { Link2, CheckCircle2, CalendarClock, GraduationCap, Search } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const sel = "bg-black border border-white/15 px-2 py-1.5 text-xs text-white focus:border-[#D4AF37] outline-none";

export default function AccountTalent({ a, mentors, token, onChange }) {
  const [busy, setBusy] = useState(false);
  const granted = a.search_granted ?? (!!a.search_access && !a.search_paid_at);
  const save = async (patch) => {
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/admin/applicants/${a.id}/profile`, patch, { headers: { Authorization: `Bearer ${token}` } });
      onChange({ ...a, ...data });
    } catch (e) { alert(e?.response?.data?.detail || "Uloženie zlyhalo."); }
    finally { setBusy(false); }
  };
  const editCert = () => {
    const v = window.prompt("Číslo certifikátu / dokladu zo Siene slávy (napr. Sa.Eko.Prs.2026-0014):", a.hof_cert_no || "");
    if (v !== null) save({ hof_cert_no: v.trim(), hof_claim_pending: false });
  };

  if (a.type === "company") return (
    <div className="mt-3 flex flex-wrap items-center gap-3 text-xs" data-testid="account-talent">
      <button disabled={busy} onClick={() => save({ search_access: !granted })} data-testid="account-search-access"
        className={`inline-flex items-center gap-1.5 px-3 py-1.5 border transition-colors ${granted ? "border-emerald-400/50 text-emerald-300" : "border-white/15 text-white/60 hover:border-[#D4AF37]/50"}`}>
        <Search size={13} /> {granted ? "Prístup k databáze kandidátov zdarma (zapnutý)" : "Prideliť prístup k databáze kandidátov zdarma"}
      </button>
    </div>
  );

  return (
    <div className="mt-3 flex flex-wrap items-center gap-3 text-xs" data-testid="account-talent">
      {a.hof_claim_pending ? (
        <span className="inline-flex items-center gap-2 px-2.5 py-1 border border-[#D4AF37]/60 bg-[#D4AF37]/10 text-[#F2E3C6]" data-testid="account-claim-pending">
          <Link2 size={13} /> Čaká na potvrdenie: {a.hof_cert_no}
          <button disabled={busy} onClick={() => save({ hof_claim_pending: false })} data-testid="account-claim-approve" className="inline-flex items-center gap-1 text-emerald-300 hover:underline"><CheckCircle2 size={13} /> Potvrdiť</button>
        </span>
      ) : (
        <button onClick={editCert} data-testid="account-hof-cert" className="inline-flex items-center gap-1.5 px-2.5 py-1 border border-white/15 text-white/60 hover:border-[#D4AF37]/50">
          <Link2 size={13} /> {a.hof_cert_no ? `Sieň slávy: ${a.hof_cert_no}` : "Prepojiť so Sieňou slávy"}
        </button>
      )}
      <span className="inline-flex items-center gap-1.5 text-white/55" data-testid="account-available-from"><CalendarClock size={13} className="shrink-0" />
        Voľný od: {a.available_from ? new Date(a.available_from).toLocaleDateString("sk-SK") : "nezadal"}
      </span>
      <label className="inline-flex items-center gap-1.5 text-white/55"><GraduationCap size={13} /> Mentor
        <select value={a.assigned_mentor_id || ""} onChange={(e) => save({ assigned_mentor_id: e.target.value })} data-testid="account-assign-mentor" className={sel}>
          <option value="">— nepridelený —</option>
          {mentors.filter((m) => m.id !== a.id).map((m) => <option key={m.id} value={m.id}>{m.name}</option>)}
        </select>
      </label>
      {a.track && <span className="text-white/40">Cieľ: {a.track === "certificate" ? "Certifikát Sa.Eko.Prs." : "Preverenie"}</span>}
    </div>
  );
}
